import React, { Component } from "react"
import { Helmet } from "react-helmet"
import axios from "axios"

import HeaderLarge from "../components/home/HeaderLarge/HeaderLarge"
import Initiatives from "../components/home/Initiatives/Initiatives"
import Services from "../components/home/Services/Services"
import ANBI from "../components/home/ANBI"
import OurPeople from "../components/home/OurPeople/OurPeople"

import { Loader } from "../components/common/Loader/Loader"

export default class HomeScreen extends Component {
  constructor(props){
    super(props);
    this.state = {
      error: '',
      data: [],
      dataInitiatives: [],
      dataOurPeople: [],
      loading: false,
    }
  }

  componentDidMount() {
    this.setState({loading: true})
    axios.all([
      axios.get(`/wp-json/wp/v2/pages/126`),
      axios.get(`/wp-json/wp/v2/initiatieven?per_page=100`),
      axios.get(`/wp-json/wp/v2/onze-mensen?per_page=100`)
    ])
    .then(axios.spread((resData, resDataInitiatives, resDataOurPeople) => {
      this.setState({
        data: resData.data,
        dataInitiatives: resDataInitiatives.data,
        dataOurPeople: resDataOurPeople.data,
        loading: false
      })
    }))
    .catch(error => {
      console.log(error);
    });
  }
  render() {
    const { data, dataInitiatives, dataOurPeople, loading } = this.state
    return (
      loading === true ? <Loader/> :
      <div>
        <Helmet>
          <title>{data.yoast_title && data.yoast_title}</title>
          <meta name={data.yoast_meta && data.yoast_meta[0].name} content={data.yoast_meta && data.yoast_meta[0].content} />
        </Helmet>
        <HeaderLarge data={data}/>
        {dataInitiatives && dataInitiatives.length > 0 && (<Initiatives data={dataInitiatives}/>)}
        <Services data={data}/>
        {/* { data && <ANBI data={data}/>} */}
        {dataOurPeople && dataOurPeople.length > 0 && (<OurPeople data={dataOurPeople}/>)}
      </div>
    )
  }
}
